// [GEN-AI-ASSISTED]
window.mcb.forms.core = function ({
  targetId,
  identity,
  pages,
  settings,
  logic
}) {
  const _logger = window.mcb.utilities.createLogger("forms.core", null, false);
  _logger.log('Initializing form:', targetId);

  const _classBase = window.mcb.forms.constants.classRoot;

  let internalCountDownTimer = null;
  let internalAttachmentResults = [];
  let internalSubmitResponse = null;
  const retryLogic = {
    constant: 0,
    linear: 1,
    exponential: 2
  };

  /* init */
  if (window.mcb.forms.debug) {
    _logger.log('window.mcb.forms.core init');
    _logger.log('targetId:', targetId);
    _logger.log('logic:', logic);
    _logger.log('settings:', settings);
    _logger.log('pages:', pages);
  }

  const _targetId = targetId;
  const _identity = identity;
  let _data;
  let _meta;
  const _formLogic = jQuery.extend(
    true, {},
    logic
  );

  const _formSettings = jQuery.extend(
    true, {},
    settings
  );

  window.mcb.forms.nudetect.load(_formLogic.nuDetect);
  window.mcb.forms.recaptcha.load(_formLogic.recaptcha);

  window.mcb.forms.data.set_FormLogics(_targetId, _formLogic);
  window.mcb.forms.data.set_FormSettings(
    _targetId,
    _formSettings
  );

  const _pages = [];
  for (let page of pages) {
    _pages.push(new window.mcb.forms.page(_targetId, _formLogic.prefills, page));
  }

  let formElement = null;
  let getFormIdentifierCandidate = function (targetId, ownerType) {
    let formIdentifier = null;
    jQuery('#' + targetId)
      .parents(ownerType)
      .find('h1,h2,h3')
      .each(function () {
        let jThis = jQuery(this);
        if (jThis.parents('#' + targetId).length === 0) {
          formIdentifier = jThis.text().trim();
          return false; // break;
        }
      });

    return formIdentifier;
  };

  let getFormIdentifier = function (formObject) {
    let formIdentifier = getFormIdentifierCandidate(
      formObject.targetId,
      'form'
    );

    if (formIdentifier === null) {
      formIdentifier = getFormIdentifierCandidate(
        formObject.targetId,
        '.mcb-ribbon--area'
      );
    }

    if (formIdentifier === null) {
      formIdentifier = getFormIdentifierCandidate(
        formObject.targetId,
        '.mcb-ribbon--content'
      );
    }

    if (formIdentifier === null) {
      formIdentifier = 'Unknown Form';
    }

    return formIdentifier;
  };

  const removeElementsWithClass = function (root, className) {
    let elementsToRemove = root.getElementsByClassName(className);
    while (elementsToRemove.length > 0) {
      _logger.trace('removing', className, elementsToRemove[0]);
      elementsToRemove[0].parentNode.removeChild(elementsToRemove[0]);
    }
  };

  const setControlsEnabledState = function (formElement, setEnabledTo = true) {
    formElement.querySelectorAll(window.mcb.forms.constants.formButtonSelector).forEach((button) => {
      button.disabled = !setEnabledTo;
    });
  };

  const setFormInteractionEnabledState = function (formElement, setEnabledTo) {
    const controls = formElement.querySelectorAll('input, textarea, select, button');
    if (!setEnabledTo) {
      const previousStates = new Map();
      controls.forEach((control) => {
        previousStates.set(control, control.disabled);
        control.disabled = true;
      });
      formElement._recaptchaControlStates = previousStates;
      return;
    }

    const previousStates = formElement._recaptchaControlStates;
    if (previousStates === undefined) {
      return;
    }

    controls.forEach((control) => {
      if (previousStates.has(control)) {
        control.disabled = previousStates.get(control);
      }
    });
    delete formElement._recaptchaControlStates;
  };

  const blockFormForRecaptcha = function (formElement) {
    setFormInteractionEnabledState(formElement, false);
    setVisibilityOfContent(formElement, true, true, true);
  };

  const showRecaptchaLoadError = function (formObject) {
    blockFormForRecaptcha(document.getElementById(formObject.targetId));
    formObject.updateFormWithMessage(
      formObject,
      formObject.getMessageFromToken(
        'RecaptchaUnavailableText',
        'This form is temporarily unavailable because security validation could not be loaded. Please try again later.'
      ),
      [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass],
      true,
      window.mcb.forms.constants.notifications.canvasBefore
    );
  };

  const setVisibilityOfPages = function (formElement, show) {
    formElement.querySelectorAll('.mcb-webform--pages').forEach((element) => {
      if (show) {
        _logger.trace('showing', element);
        element.classList.remove(window.mcb.forms.constants.hidden);
      }
      else {
        _logger.trace('hiding', element);
        element.classList.add(window.mcb.forms.constants.hidden);
      }
    });
  };

  const refreshFooterVisibility = function (formElement) {
    formElement.querySelectorAll('.mcb-webform--footer').forEach((element) => {
      let show = false;
      for (const child of element.children) {
        if (child.children.length > 0 && !child.classList.contains(window.mcb.forms.constants.hidden)) {
          show = true;
          break;
        }
      }

      if (show) {
        _logger.trace('showing footer', element);
        element.classList.remove(window.mcb.forms.constants.hidden);
      }
      else {
        _logger.trace('hiding footer', element);
        element.classList.add(window.mcb.forms.constants.hidden);
      }
    });
  };

  const setVisibilityOfControls = function (formElement, show) {
    formElement.querySelectorAll('.mcb-webform--controls').forEach((element) => {
      if (show) {
        _logger.trace('showing', element);
        element.classList.remove(window.mcb.forms.constants.hidden);
      }
      else {
        _logger.trace('hiding', element);
        element.classList.add(window.mcb.forms.constants.hidden);
      }
    });

    refreshFooterVisibility(formElement);
  };

  const setVisibilityOfFormNotifications = function (formElement, show) {
    formElement.querySelectorAll('.mcb-webform--notification--canvas').forEach((element) => {
      if (show) {
        _logger.trace('showing', element);
        element.classList.remove(window.mcb.forms.constants.hidden);
      }
      else {
        _logger.trace('hiding', element);
        element.classList.add(window.mcb.forms.constants.hidden);
      }
    });

    if (!show) {
      formElement.querySelectorAll('.mcb-webform--notification--message').forEach((element) => {
        _logger.trace('hiding and removing', element);
        element.classList.add(window.mcb.forms.constants.hidden);
        element.classList.add(window.mcb.forms.constants.removing);
      });

      setTimeout(function () {
        removeElementsWithClass(formElement, window.mcb.forms.constants.removing);
      }, 300);
    }
  };

  const resetRecaptchaForRetry = function (formObject) {
    const formElement = document.getElementById(formObject.targetId);
    const recaptchaCanvas = formElement.querySelector('.' + _classBase + 'recaptcha');
    if (recaptchaCanvas !== null) {
      window.mcb.forms.recaptcha.clearV2Widget(recaptchaCanvas);
      recaptchaCanvas.classList.add(window.mcb.forms.constants.hidden);
    }

    _meta['recaptchaToken'] = null;
  };

  const setVisibilityOfContent = function (formElement, showPages = true, showControls = true, showNotifications = false) {
    _logger.trace('setVisibilityOfContent', {
      showPages,
      showControls,
      showNotifications
    });

    setVisibilityOfPages(formElement, showPages);
    setVisibilityOfControls(formElement, showControls);
    setVisibilityOfFormNotifications(formElement, showNotifications);
  };

  let executeSubmit = function (formObject) {
    internalAttachmentResults = [];
    internalSubmitResponse = null;

    const formElement = document.getElementById(formObject.targetId);
    setVisibilityOfContent(formElement, false, false, true);

    formObject.extendValueObject(formObject, _data);

    window.mcb.tracking.track('FormSubmitting', {
      identifier: getFormIdentifier(formObject),
      id: 'Submitting'
    });

    let payload = compileNaivePayload(formObject);
    if (payload !== null) {
      submitFormData(formObject, 'json', payload);
      return;
    }

    if (formObject.settings.forceSingleSubmit === true) {
      formObject.updateFormWithMessage(
        formObject,
        formObject.getMessageFromToken('submitTooLargeErrorText').replace('{data}', window.mcb.forms.helpers.renderFileSize(formObject.settings.maxSizes.singleSubmit)),
        [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass]
      );

      setControlsEnabledState(formElement, true);
      setVisibilityOfContent(formElement, true, true, true);
      resetRecaptchaForRetry(formObject);

      let formIdentifier = getFormIdentifier(formObject);
      window.mcb.tracking.track('FormSubmitError', {
        identifier: formIdentifier,
        id: 'SubmitTooLargeError'
      });
    }
    else {
      let compilation = compileStrippedPayload(formObject);
      if (compilation.payload === null) {
        formObject.updateFormWithMessage(
          formObject,
          formObject.getMessageFromToken('submitTooLargeErrorText').replace('{data}', compilation.maxSizeViolation),
          [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass]
        );

        setControlsEnabledState(formElement, true);
        setVisibilityOfContent(formElement, true, true, true);
        resetRecaptchaForRetry(formObject);

        let formIdentifier = getFormIdentifier(formObject);
        window.mcb.tracking.track('FormSubmitError', {
          identifier: formIdentifier,
          id: 'SubmitTooLargeError'
        });
      }
      else {
        _logger.log('Submit Payload without files');
        if (typeof files !== 'undefined') {
          compilation.files = files;
        }

        trackMe(formObject);

        formObject.updateFormWithMessage(
          formObject,
          formObject.getMessageFromToken('submittingFirstOfManyText'),
          [window.mcb.forms.constants.messages.progressClass]
        );

        formObject.attachmentCount = compilation.files.length;

        submitFormDataAndThen(formObject, 'json', compilation, function (response) {
          let responseData = checkResponse(formObject, response);
          if (responseData !== null) {
            let appendTo = responseData.result ?? null;
            if (appendTo !== null && appendTo !== "null") {
              internalSubmitResponse = JSON.parse(JSON.stringify(responseData));
              internalSubmitResponse.result = internalSubmitResponse.data.CaseNumber;
              delete internalSubmitResponse.data;

              appendFileFromArray(formObject, appendTo, compilation.files, 0);
            }
            else {
              _logger.warn('Something went wrong when submitting Form Data - Assume unrecoverable error');
              formObject.onSubmitServersideDone(formObject, response);
            }
          }
        });
      }
    }
  };

  let checkResponse = function (formObject, response) {
    if (response.responseText !== null && response.responseText.length > 2) {
      try {
        if (response.responseText[0] === '{') {
          return JSON.parse(response.responseText);
        }

        if (response.responseText[0] === '[') {
          return JSON.parse(response.responseText)[0];
        }
      }
      catch (ex) {
        _logger.error('JSON parsing failed', response.responseText);
        errorMessage = formObject.getMessageFromToken('ErrorMessageFailedToParseResponse', null);
      }
    }

    return {
      statusCode: response.status,
      result: response.responseText,
      tryAgain: false
    };
  }

  let submitFormDataAndThen = function (formObject, type, compilation, onCompleted) {
    let blob = new Blob([compilation.payload], {
      type: 'application/json'
    });

    try {
      _logger.trace('Generating FormData');
      let fdata = new FormData();

      _logger.trace('Appending data');
      fdata.append('mc_file', blob, formObject.targetId + '.' + type);
      fdata.append('mc_identity', formObject.identity);
      fdata.append('mc_src', window.location.href);

      let files = compilation.files ?? [];
      if (files.length > 0) {
        fdata.append('mc_attachments', files.length);
      }

      for (let prop in _meta) {
        if (_meta.hasOwnProperty(prop)) {
          const val = _meta[prop];
          if (val !== null) {
            fdata.append('mc_' + prop, _meta[prop]);
          }
        }
      }

      _meta = {}; // Reset

      _logger.trace('Generating XMLHttpRequest');
      let request = new XMLHttpRequest();

      _logger.trace('Adding post location');
      let url = location.origin + formObject.settings.submitUrlBase + '/submit';
      request.open('POST', url, true);

      _logger.trace('Adding onreadystatechange');
      request.onreadystatechange = function () {
        _logger.trace('onReadyStateChange fired: ' + request.readyState);
        if (request.readyState === 4) {
          _logger.trace('Done', request);
          onCompleted(request);
        }
      };

      _logger.trace('Submitting XMLHttpRequest to ' + url);
      request.send(fdata);
    }
    catch (exx) {
      _logger.warn('ERROR:');
      _logger.error(exx);
    }

    trackMe(formObject);
  };

  let submitFormData = function (formObject, type, payload) {
    submitFormDataAndThen(formObject, type, { payload }, function (responseData) {
      _logger.log('Form was submitted as One Shot');
      formObject.onSubmitServersideDone(formObject, responseData);
    });

    formObject.updateFormWithMessage(
      formObject,
      formObject.getMessageFromToken('submittingText'),
      [window.mcb.forms.constants.messages.progressClass]
    );
  };

  let compileNaivePayload = function (formObject) {
    let payload = JSON.stringify(_data);
    let size = payload.length;
    for (let item of _data.data) {
      let value = item.value;
      if (Array.isArray(value)) {
        for (let file of value) {
          if (typeof file.getSize !== 'undefined') {
            size += file.getSize();
          }
        }
      }
    }

    if (size < formObject.settings.maxSizes.singleSubmit) {
      _logger.trace('Total size is small (' + size + ' < ' + formObject.settings.maxSizes.singleSubmit + '), sending as JSON');
      for (let item of _data.data) {
        let value = item.value;
        if (Array.isArray(value)) {
          _logger.trace('Converting files to Array Data');
          for (let file of value) {
            if (typeof file.toArray !== 'undefined') {
              file.data = file.toArray();
            }
          }
        }
      }

      return JSON.stringify(_data);
    }

    _logger.trace('Total size is not small');
    return null;
  };

  let compileStrippedPayload = function (formObject) {
    let files = [];
    let filesSize = 0;
    for (let item of _data.data) {
      let value = item.value;
      if (typeof value === "object" && Array.isArray(value)) {
        const names = [];
        let fieldFiles = [];
        for (let i = value.length - 1; i >= 0; i--) {
          names.push(value[i].name);
          filesSize += value[i].getSize();
          fieldFiles.push(value.splice(i, 1)[0]);
          fieldFiles[fieldFiles.length - 1].field = item.alias;
        }

        fieldFiles.reverse();
        files = files.concat(fieldFiles);

        item.value = names.join('\n');
      }
    }

    let payload = JSON.stringify(_data);
    let maxSizeViolation = null;
    if (payload.length > formObject.settings.maxSizes.singleSubmit) {
      _logger.warn('Base Data Payload size is unacceptable (' + payload.length + ' > ' + formObject.settings.maxSizes.singleSubmit + ')');
      maxSizeViolation = window.mcb.forms.helpers.renderFileSize(formObject.settings.maxSizes.singleSubmit);
      payload = null;
      files = [];
    }
    else if (payload.length + filesSize > formObject.settings.maxSizes.sequentialSubmits) {
      _logger.warn('Combined Data Payload size is unacceptable (' + payload.length + ' > ' + formObject.settings.maxSizes.sequentialSubmits + ')');
      maxSizeViolation = window.mcb.forms.helpers.renderFileSize(formObject.settings.maxSizes.sequentialSubmits);
      payload = null;
      files = [];
    }

    return {
      files,
      payload,
      maxSizeViolation
    };
  }

  const compileAttachmentResults = function (files) {
    let results = null;
    let failedFiles = internalAttachmentResults.filter((response) => response.result !== null && response.result.statusCode !== 1);
    if (files.length > 0) {
      const existingErrors = [...new Set(failedFiles.map((response) => response.result.statusCode))];
      const newError = existingErrors.length === 1 ? existingErrors[0] : 20500;
      for (let i = 0; i < files.length; i++) {
        internalAttachmentResults.push({
          attempts: 0,
          name: files[0].name,
          result: {
            statusCode: newError
          }
        });
      }

      failedFiles = internalAttachmentResults.filter((response) => response.result !== null && response.result.statusCode !== 1);
    }

    const unkownResults = internalAttachmentResults.filter((response) => response.result === null);
    if (unkownResults.length === 0 && failedFiles.length === 0) {
      results = {
        status: 200,
        responseText: JSON.stringify([internalSubmitResponse])
      };
    }
    else {
      const internalAttachmentFailures = [internalSubmitResponse];
      if (failedFiles.length > 0) {
        _logger.warn('failedFiles', failedFiles);

        var errorTypes = Object.groupBy(failedFiles, (response) => response.result.statusCode);
        for (var errorType in errorTypes) {
          const system = errorTypes[errorType][0].result.system;
          internalAttachmentFailures.push({
            statusCode: errorType,
            system,
            results: errorTypes[errorType].map((response) => response.name).join('<br>')
          });
        }
      }

      if (unkownResults.length > 0) {
        _logger.error('unkownResults', unkownResults);

        internalAttachmentFailures.push({
          statusCode: '20001'
        });
      }

      results = {
        status: unkownResults.length === 0 ? 202 : 500,
        responseText: JSON.stringify(internalAttachmentFailures)
      };
    }

    internalAttachmentResults = [];
    internalSubmitResponse = null;

    return results;
  };

  let appendFileFromArray = function (formObject, appendToId, files, index) {
    let file = files.shift();

    while (internalAttachmentResults.length <= index) {
      internalAttachmentResults.push({
        attempts: 0,
        name: file.name,
        result: null
      });
    }

    let attemptCount = internalAttachmentResults[index].attempts + 1;
    _logger.trace('Generating FormBlob: ' + file.name);

    try {
      let blob = new Blob([file.data], {
        type: file.type
      });

      let fdata = new FormData();
      _logger.log('Appending file: ' + file.name + ' (attempt ' + attemptCount + ')');
      fdata.append('mc_file', blob, file.name);
      fdata.append('mc_identity', formObject.identity);
      fdata.append('mc_src', window.location.href);
      fdata.append('mc_field', file.field);
      fdata.append('mc_appendTo', appendToId);

      _logger.trace('Generating XMLHttpRequest');
      let request = new XMLHttpRequest();
      _logger.trace('Adding post location');
      let url = location.origin + formObject.settings.submitUrlBase + '/attach';
      request.open('POST', url, true);
      _logger.trace('Adding onreadystatechange');
      request.onreadystatechange = function () {
        _logger.trace('onReadyStateChange fired: ' + request.readyState);
        if (request.readyState === 4) {
          _logger.trace('Partial Submit Done: ', request);

          let responseData = checkResponse(formObject, request);
          internalAttachmentResults[index].result = responseData;

          appendToId = responseData.result;
          if (responseData.statusCode === 1) {
            _logger.trace('Attachment call succeeded');
            if (files.length === 0) {
              _logger.trace('Last file submitted, Form Submit is done');
              formObject.onSubmitServersideDone(formObject, compileAttachmentResults(files));
            }
            else {
              _logger.trace('Append next file');
              appendFileFromArray(formObject, appendToId, files, index + 1);
            }
          }
          else {
            window.mcb.tracking.track('FormSubmitFileFailure', {
              identifier: getFormIdentifier(formObject),
              id: attemptCount,
              value: file.name
            });

            if (responseData.tryAgain === false) {
              _logger.error('Attachment failed, and the error is unrecoverable');
              formObject.onSubmitServersideDone(formObject, compileAttachmentResults(files));
            }
            else {
              _logger.warn('Attachment failed (' + attemptCount + ' of ' + formObject.settings.attachmentMaxAttempts + ')');
              if (attemptCount >= formObject.settings.attachmentMaxAttempts) {
                _logger.error('Too many attemps have been made for this file(!)');
                if (files.length === 0) {
                  _logger.trace('The failed file was the last one, Form Submit is done');
                  formObject.onSubmitServersideDone(formObject, compileAttachmentResults(files));
                  return;
                }

                if (formObject.settings.attachmentTrySubsequentOnError === true) {
                  _logger.trace('Trying to append next file');
                  appendFileFromArray(formObject, appendToId, files, index + 1);
                  return;
                }

                _logger.warn('Since one Form Attachment failed, we will not try to append the remaining files');
                formObject.onSubmitServersideDone(formObject, compileAttachmentResults(files));
                return;
              }
              else {
                files.unshift(file);

                let wait;
                switch (parseInt(formObject.settings.attachmentRetryLogic)) {
                  case retryLogic.exponential:
                    wait = Math.pow(attemptCount * formObject.settings.attachmentRetryTimerOffset, 2);
                    break;
                  case retryLogic.linear:
                    wait = formObject.settings.attachmentRetryTimerOffset * attemptCount;
                    break;
                  case retryLogic.constant:
                  default:
                    wait = formObject.settings.attachmentRetryTimerOffset;
                    break;
                }

                formObject.updateFormWithMessage(
                  formObject,
                  formObject.getMessageFromToken('submittingXofYTextRetry')
                    .replace(/{index}/g, index + 1)
                    .replace(/{count}/g, formObject.attachmentCount)
                    .replace(/{wait}/g, wait),
                  [window.mcb.forms.constants.messages.progressClass]
                );

                updateCountdown();

                setTimeout(function () {
                  _logger.log('Retry to append current file');
                  appendFileFromArray(formObject, appendToId, files, index);
                }, wait * 1000);

                return;
              }
            }
          }
        }
      };

      _logger.trace('Submitting Append XMLHttpRequest for ' + index + ' (' + file.name + ') as attempt ' + attemptCount + ' to ' + url);

      internalAttachmentResults[index].attempts = attemptCount;

      request.send(fdata);
    } catch (exx) {
      _logger.warn('ERROR:');
      _logger.error(exx);
    }

    let formIdentifier = getFormIdentifier(formObject);
    window.mcb.tracking.track('FormSubmittingFile', {
      identifier: formIdentifier,
      id: index,
      value: file.name
    });

    formObject.updateFormWithMessage(
      formObject,
      formObject.getMessageFromToken('submittingXofYText').replace(/{index}/g, index + 1).replace(/{count}/g, formObject.attachmentCount),
      [window.mcb.forms.constants.messages.progressClass]
    );
  };

  let updateCountdown = function () {

    clearTimeout(internalCountDownTimer);
    internalCountDownTimer = setTimeout(function () {
      let runAgain = false;
      jQuery('.' + window.mcb.forms.constants.countdown).each(function () {
        let val = jQuery(this).text().trim();
        if (val !== '' && !isNaN(val)) {
          val = parseInt(val);
          if (val > 0) {
            val--;
            if (val > 0) {
              jQuery(this).text(val);
              runAgain = true;
            }
          }
        }
      });

      if (runAgain === true) {
        updateCountdown();
      }
      else {
        clearTimeout(internalCountDownTimer);
      }
    }, 1000);
  }

  let strToUtf16Bytes = function (str) {
    let bytes = [];
    for (ii = 0; ii < str.length; ii++) {
      let code = str.charCodeAt(ii);     // x00-xFFFF
      bytes.push(code & 255, code >> 8); // low, high
    }

    return bytes;
  };

  let trackMe = function (formObject) {
    let formIdentifier = getFormIdentifier(formObject);
    window.mcb.tracking.track('FormSubmitting', {
      identifier: formIdentifier,
      id: undefined,
      value: undefined
    });
  };

  const parseResponseData = function (response) {
    try {
      return JSON.parse(response.responseText);
    }
    catch (ex) {
      return {
        type: 'parseError',
        error: ex,
        responseText: response.responseText
      };
    }
  }

  const convertToPascalCase = function (input) {
    if (typeof input !== 'string') {
      return convertToPascalCase(input.toString());
    }

    const preserveAbbreviations = input.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
    const removeSpecialChars = preserveAbbreviations.replace(/[\W_]+/g, " ");
    const cleaned = removeSpecialChars.toLowerCase().trim();

    const cameled = cleaned.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (+match === 0) return "";
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });

    return cameled;
  }

  const convertToCamelCase = function (input) {
    const pascalled = convertToPascalCase(input);
    if (pascalled.length > 1) {
      return pascalled[0].toLowerCase() + pascalled.substring(1);
    }

    return pascalled.toLowerCase();
  }

  const compileSubmitErrorMessage = function (formObject, data) {
    const messages = data.filter((row) => typeof row.statusCode === "undefined" || row.statusCode != "1").map((error) => {
      const codeOnly = typeof error === 'number' || typeof error === 'string';
      const code = codeOnly ? error : error.statusCode;
      let errorMessage = window.mcb.forms.data.getErrorMessageFromCode(formObject.targetId, code);
      if (errorMessage !== null) {
        if (codeOnly) {
          return errorMessage;
        }
        else {
          const system = error.system.replace(/\s/g, '');
          return enrichMessage(errorMessage, system, error);
        }
      }

      return code.toString();
    }).filter((message) => { return message !== null; });

    const compiled = messages.length === 1 ? messages[0] : ('<br>' + messages.join('<br>'));
    return formObject.getMessageFromToken('SubmitErrorText').replace(/{#FormResult#}/g, compiled);
  };

  const compileSubmitSuccessMessage = function (formObject, data) {
    let displaymessage = formObject.getMessageFromToken('SubmitSuccessText');
    data.filter((row) => typeof row.result !== 'undefined' && row.statusCode == "1").forEach((success) => {
      const system = success.system.replace(/\s/g, '');
      displaymessage = enrichMessage(displaymessage, system, success);
    });

    return displaymessage;
  };

  const enrichMessage = function (message, system, data) {
    let result = data.result;
    if (typeof result === "string" && (result[0] === '[' || result[0] === '{')) {
      try {
        result = JSON.parse(data.result);
      }
      catch (ex) {
        _logger.error("Failed to parse returned data", ex, data.result);
      }
    }

    let raw = '';
    if (typeof result === "string") {
      raw = result;
      message = message.replaceAll('{#FormResult:' + system + '#}', result);
    }
    else if (typeof result === "object") {
      for (let prop in result) {
        if (Object.hasOwn(result, prop)) {
          const val = result[prop];
          message = message.replaceAll('{#FormResult:' + system + ':' + prop + '#}', val);

          if (typeof val === 'boolean') {
            message = message.replaceAll('{#FormResult:' + system + ':' + prop + ':Switch#}', (val ? 'a' : 'b'));
          }

          if (typeof val === 'number') {
            message = message.replaceAll('{#FormResult:' + system + ':' + prop + ':Switch#}', (val === 0 ? 'a' : (val === 1 ? 'b' : 'c')));
          }
        }
      }
    }

    if (raw === '') {
      message = message.replaceAll(': {#FormResult#}', raw);
    }

    if (typeof data.data !== 'undefined' && message.indexOf('{') >= 0) {
      for (let prop in data.data) {
        if (Object.hasOwn(data.data, prop)) {
          const val = data.data[prop];
          message = message.replaceAll('{' + prop + '}', val);
        }
      }
    }

    return message.replaceAll('{#FormResult#}', raw);
  };

  const onSubmitServersideDone = function (formObject, response) {
    _logger.log('Submition Completed', response);

    jQuery('#' + formObject.targetId + '_btnCommitForm')
      .prop('disabled', false)
      .show();

    let displaymessage = null;
    let displayClasses = [];
    let trackType = 'FormSubmitError';
    let skipSharedTrack = false;
    let trackId = null;
    const formIdentifier = getFormIdentifier(formObject);
    const data = parseResponseData(response);

    if (data.type === 'parseError') {
      trackId = data.type;
      displayClasses.push(window.mcb.forms.constants.messages.messageClass);
      displayClasses.push(window.mcb.forms.constants.validation.messageFailureClass);
      displaymessage = formObject
        .getMessageFromToken('SubmitErrorText')
        .replace(
          '{#FormResult#}',
          formObject.getMessageFromToken("ErrorMessageFailedToParseResponse", data.error)
        );

      jQuery(document).trigger('webforms:onsubmiterror', [formObject, data]);
    }
    else if (response.status === 200) {
      trackType = 'FormSubmitSuccess';
      displayClasses.push(window.mcb.forms.constants.validation.messageSuccessClass);
      displaymessage = compileSubmitSuccessMessage(formObject, data);
      jQuery(document).trigger('webforms:onsubmitsuccess', [formObject, data]);
    }
    else if (response.status === 202) {
      skipSharedTrack = true;
      displayClasses.push(window.mcb.forms.constants.validation.messagePartialClass);

      const errorMessage = compileSubmitErrorMessage(formObject, data);
      const successMessage = compileSubmitSuccessMessage(formObject, data);

      displaymessage = '<div class="' + window.mcb.forms.constants.validation.successMessage + '">' + successMessage + '</div>' +
        '<div class="' + window.mcb.forms.constants.validation.failureMessage + '">' + errorMessage + '</div>';

      window.mcb.tracking.track('FormSubmitPartialSuccess', {
        identifier: formIdentifier,
        id: data.map((row) => row.result ?? null).filter((row) => row !== null).join(','),
        value: successMessage
      });

      window.mcb.tracking.track('FormSubmitPartialError', {
        identifier: formIdentifier,
        id: data.filter((row) => typeof row === 'number').join(','),
        value: errorMessage
      });

      jQuery(document).trigger('webforms:onsubmitpartial', [formObject, data]);
    }
    else {
      trackId = data.join(',');
      displayClasses.push(window.mcb.forms.constants.messages.messageClass);
      displayClasses.push(window.mcb.forms.constants.validation.messageFailureClass);
      displaymessage = compileSubmitErrorMessage(formObject, data);

      jQuery(document).trigger('webforms:onsubmiterror', [formObject, data]);
    }

    jQuery('#' + formObject.targetId + ' .' + window.mcb.forms.constants.pages.collectionClass).remove();
    jQuery('#' + formObject.targetId + ' .' + window.mcb.forms.constants.classRoot + 'controls').remove();

    formObject.updateFormWithMessage(
      formObject,
      displaymessage,
      displayClasses
    );

    if (skipSharedTrack === false) {
      window.mcb.tracking.track(trackType, {
        identifier: formIdentifier,
        id: trackId,
        value: displaymessage
      });
    }
  };

  const completeNuDetectChallenge = function (clickEvent, formObject, answer) {
    clickEvent.preventDefault();
    _logger.log('completeNuDetectChallenge', clickEvent);
    const canvas = clickEvent.target.closest('.' + _classBase + 'nucaptcha');
    window.mcb.forms.nudetect.applyNuDetect(canvas, answer, presentNuDetectChallenge, onNuDetectSuccess, onNuDetectError, formObject);
  };

  const updateNuDetectChallenge = function (canvas, challenge, formObject) {
    const captchaOriginalInputElement = canvas.querySelector('#nucaptcha-answer');
    if (!captchaOriginalInputElement) {
      setTimeout(function () {
        updateNuDetectChallenge(canvas, challenge, formObject);
      }, 50);

      return;
    }

    const captchaOriginalLabelElement = canvas.querySelector('#directions-verbose-label');
    const captchaInputCanvas = document.createElement('div');
    captchaOriginalInputElement.parentElement.insertBefore(captchaInputCanvas, captchaOriginalInputElement);

    const captchaInputElement = new window.mcb.forms.field(formObject.targetId, _formLogic.prefills, {
      name: captchaOriginalInputElement.name,
      title: captchaOriginalLabelElement.innerText.trim(),
      defaultValue: '',
      type: 'Text',
      fieldValueControlId: captchaOriginalInputElement.id,
      addControlClasses: captchaOriginalInputElement.className.split(' '),
      required: true,
      condition: null,
      showTitle: true,
      placeholder: null,
      autocomplete: "off",
      aria: null,
      description: null,
      data: {
        type: 'text',
        regex: null,
        regexError: null,
        maxlength: 3,
        minlength: 3,
        min: null,
      },
      events: {
        onRendered: function (field, target, fieldGroup, validatedControl) {
          validatedControl.querySelector('input').addEventListener('keypress', function (event) {
            if (event.key === "Enter") {
              event.preventDefault();
              const value = captchaInputElement.getValue();
              if (value !== null && typeof value !== 'undefined' && value.length === 3) {
                completeNuDetectChallenge(event, formObject, value);
              }
            }
          });
        }
      }
    });

    captchaOriginalInputElement.remove();
    captchaOriginalLabelElement.remove();

    captchaInputElement.render(captchaInputCanvas);

    challenge.querySelectorAll('label').forEach((label) => {
      label.classList.add('mcb-webform--field--label');
    });

    const controls = document.createElement('div');
    controls.classList.add('mcb-webform--nucaptcha-controls');
    canvas.append(controls);

    const button = document.createElement('button');
    button.type = 'button';
    button.classList.add(window.mcb.forms.constants.formButtonClass);
    button.addEventListener("click", function (event) {
      const value = captchaInputElement.getValue();
      if (value !== null && typeof value !== 'undefined') {
        completeNuDetectChallenge(event, formObject, value);
      }
    });
    controls.append(button);

    const buttonContent = document.createElement('span');
    buttonContent.classList.add('button-message');
    buttonContent.innerHTML = formObject.getMessageFromToken('submitText');
    button.append(buttonContent);

    refreshFooterVisibility(challenge.closest('form'));
  };

  const presentNuDetectChallenge = function (canvas, challengeHtml, formObject) {
    window.mcb.tracking.track('FormPresentedCaptcha', {
      identifier: canvas.dataset.formIdentifier,
      id: 'Displayed Captcha',
      value: 'Displayed Captcha'
    });

    const frag = document.createRange().createContextualFragment(challengeHtml);

    const challenge = document.createElement('div');
    challenge.classList.add('mcb-webform--nucaptcha-challenge');
    challenge.appendChild(frag);
    canvas.append(challenge);

    updateNuDetectChallenge(canvas, challenge, formObject);
  };

  const onNuDetectSuccess = function (canvas, formObject, nudetectResponse) {
    for (let prop in nudetectResponse) {
      if (nudetectResponse.hasOwnProperty(prop)) {
        const authKey = 'nuDetect' + prop[0].toUpperCase() + prop.substring(1);
        const authValue = nudetectResponse[prop];
        _logger.trace("Add NuDetect Propery: ", authKey, authValue);
        _meta[authKey] = authValue;
      }
    }

    _logger.trace("Updated Meta Data from NuDetect Data: ", _meta, nudetectResponse);
    removeElementsWithClass(canvas, 'mcb-webform--nucaptcha');

    const formElement = canvas.closest('form');
    refreshFooterVisibility(formElement);

    formElement.classList.remove(window.mcb.forms.constants.authenticationIsActive);

    executeSubmit(formObject);
  };

  const onNuDetectError = function (canvas, formObject, error) {
    _logger.error('NuDetect Error', error);

    window.mcb.tracking.track('FormErrorCaptcha', {
      identifier: canvas.dataset.formIdentifier,
      id: 'Error' + error.code,
      value: error.message
    });

    const code = typeof error.code === 'number' ? error.code : 'Unknown';
    const token = 'ErrorCodeND' + code;
    const fallbackMessage = 'Unknown error occurred, please try again later';
    let message = formObject.getMessageFromToken(token.replace('{code}', code), fallbackMessage);

    formObject.updateFormWithMessage(
      formObject,
      message,
      [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass],
      true
    );

    removeElementsWithClass(canvas, 'mcb-webform--nucaptcha');

    const formElement = canvas.closest('form');
    refreshFooterVisibility(formElement);

    formElement.classList.remove(window.mcb.forms.constants.authenticationIsActive);
  }

  return _ = {
    settings: _formSettings,
    render: function () {
      formElement = document.getElementById(_targetId);
      _logger.trace("formElement", formElement);
      if (formElement === null) {
        throw new Error('Target was not found');
      }

      //window.mcb.forms.validation.registerForm(formElement);

      const parent = formElement.closest('.mcb-webpart--webform');
      for (let formType of _formSettings.formTypes) {
        parent.classList.add(_classBase + 'type--' + formType);
      }

      if (_formSettings.className !== null && _formSettings.className !== '') {
        parent.classList.add(_classBase + 'class--' + _formSettings.className);
      }

      this.renderFormHeader(formElement);

      let formIsBlockedMessage = window.mcb.forms.helpers.getFormIsBlockedMessage(_formSettings);
      if (formIsBlockedMessage !== null) {
        const warning = document.createElement('div');
        warning.classList.add(_classBase + 'error');
        warning.append(formIsBlockedMessage);
        formElement.append(warning);
      }
      else {
        const messageBeforeCanvas = document.createElement('div');
        messageBeforeCanvas.classList.add(window.mcb.forms.constants.notifications.canvas);
        messageBeforeCanvas.classList.add(window.mcb.forms.constants.notifications.canvasBefore);
        formElement.append(messageBeforeCanvas);

        const pagesElement = document.createElement('div');
        pagesElement.classList.add(window.mcb.forms.constants.pages.collectionClass);
        formElement.append(pagesElement);

        let messageAfterPageTitle = null;
        if (_formLogic.authenticateForm !== null) {
          messageAfterPageTitle = document.createElement('div');
          messageAfterPageTitle.classList.add(window.mcb.forms.constants.messages.messageClass);
          messageAfterPageTitle.classList.add('warning');
          messageAfterPageTitle.classList.add(window.mcb.forms.constants.formHasAuthentication);
          messageAfterPageTitle.innerHTML = window.mcb.forms.data.getMessageFromToken(_targetId, 'AuthenticationIsActive');
        }

        for (let i = 0; i < _pages.length; i++) {
          _pages[i].render(pagesElement, messageAfterPageTitle, this.enrichFieldFunction);
          messageAfterPageTitle = null;
        }

        for (let i = _pages.length - 1; i >= 0; i--) {
          _pages[i].onRendered();
        }

        const messageCanvas = document.createElement('div');
        messageCanvas.classList.add(window.mcb.forms.constants.notifications.canvas);
        messageCanvas.classList.add(window.mcb.forms.constants.notifications.canvasAfter);
        formElement.append(messageCanvas);

        this.renderFormFooter(formElement);

        formElement.querySelectorAll('.' + window.mcb.forms.constants.fields.dateClass).forEach((dateField) => {
          try {
            const jThis = jQuery(dateField);
            const val = jThis.val();

            jThis.datebox({});
            if (val !== '') {
              jThis.datebox('setTheDate', val);
            }
          }
          catch (err) {
            _logger.error('Failed to set date value');
          }
        });

        this.applyEvents(this);
      }

      formElement.querySelectorAll('input[data-dirty="true"]').forEach((input) => {
        input.dispatchEvent(new Event("blur", { bubbles: true }));
        input.dataset.dirty = false;
      });

      document.getElementById(_targetId + '_Script').remove();
    },
    renderFormHeader: function (formElement) {
      const head = document.createElement('div');
      head.classList.add(_classBase + 'header');

      if (_formLogic.authenticateForm !== null) {
        const warning = document.createElement('div');
        head.append(warning);
        warning.classList.add(_classBase + 'notification--warning');
        warning.classList.add(_classBase + 'notification--has-auth');
      }

      if (head.childElementCount > 0) {
        formElement.append(head);
      }
    },
    renderFormFooter: function (formElement) {
      const foot = document.createElement('div');
      formElement.append(foot);
      foot.classList.add(_classBase + 'footer');

      if (_formLogic.authenticateForm !== null) {
        const auth = document.createElement('div');
        foot.append(auth);
        auth.classList.add(_classBase + 'authenticateform');
        if (_formLogic.authenticateForm.classPostfix !== null) {
          auth.classList.add(_classBase + 'auth-' + _formLogic.authenticateForm.classPostfix);
        }
      }
      else if (_formLogic.nuDetect !== null) {
        const captcha = document.createElement('div');
        foot.append(captcha);
        captcha.classList.add(_classBase + 'block');
        captcha.classList.add(_classBase + 'nucaptcha');
      }
      else if (_formLogic.recaptcha !== null) {
        // The v2 widget is deferred: canvas starts hidden and grecaptcha.render is called on submit
        // (in onPerformCaptcha) so the token cannot expire while the user is filling in fields.
        const captcha = document.createElement('div');
        foot.append(captcha);
        captcha.classList.add(_classBase + 'block');
        captcha.classList.add(_classBase + 'recaptcha');
        captcha.classList.add(window.mcb.forms.constants.hidden);
      }

      const controls = document.createElement('div');
      foot.append(controls);
      controls.classList.add(_classBase + 'controls');

      const submit = document.createElement('button');
      controls.append(submit);
      submit.type = 'button';
      submit.id = _targetId + '_btnCommitForm';

      if (document.body.classList.contains('mcb-theme-global')) {
        submit.classList.add('mcb-button');
        submit.classList.add('mcb-button--primary');

        if (_formLogic.authenticateForm !== null) {
          submit.classList.add('mcb-button--auth');
          if (_formLogic.authenticateForm.classPostfix !== null) {
            submit.classList.add('mcb-button--auth' + _formLogic.authenticateForm.classPostfix);
          }
        }
      }
      else {
        submit.classList.add(_classBase + 'control--button');

        if (_formLogic.authenticateForm !== null) {
          submit.classList.add(_classBase + 'control--button--auth');
          if (_formLogic.authenticateForm.classPostfix !== null) {
            submit.classList.add(_classBase + 'control--button--auth' + _formLogic.authenticateForm.classPostfix);
          }
        }
      }

      const submitMessage = document.createElement('span');
      submit.append(submitMessage);
      submitMessage.classList.add(_classBase + 'control--button--message');
      submitMessage.append(window.mcb.forms.data.getMessageFromToken(_targetId, 'submitText'));

      if (_formLogic.authenticateForm !== null && _formLogic.authenticateForm.disabled === true) {
        submit.disabled = true;
      }

      if (_formLogic.recaptcha !== null) {
        blockFormForRecaptcha(formElement);
        const formObject = this;
        const loadingMessageTimer = setTimeout(function () {
          formObject.updateFormWithMessage(
            formObject,
            'This form is loading security validation. You can fill it in when validation is ready.',
            [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass],
            true,
            window.mcb.forms.constants.notifications.canvasBefore
          );
        }, 500);

        window.mcb.forms.recaptcha.whenReady()
          .then(function () {
            clearTimeout(loadingMessageTimer);
            setVisibilityOfFormNotifications(formElement, false);
            setFormInteractionEnabledState(formElement, true);
            if (_formLogic.authenticateForm !== null && _formLogic.authenticateForm.disabled === true) {
              submit.disabled = true;
            }
          })
          .catch(function () {
            clearTimeout(loadingMessageTimer);
            showRecaptchaLoadError(formObject);
          });
      }
    },
    applyEvents: function (formObject) {
      /*formElement.addEventListener('MCB.Events.WebForms.FieldUpdated.Standard', function (e) {
        const _thisField = e.detail.origin;
        const field = document.getElementById(_thisField.fieldGroupId);
        console.warn('evaluateCondition from core');
        window.mcb.forms.helpers.evaluateCondition(_thisField, field, _thisField.settings.condition, e.detail.origin, e.detail.value);
      }, false);*/

      document.getElementById(_targetId + '_btnCommitForm').addEventListener('click', async function (event) {
        _logger.trace('Commit Button Pressed');

        formObject.onCollectData(formObject);
      });
    },
    onCollectData: async function (formObject) {
      formElement.classList.add(window.mcb.forms.constants.valueCollectingIsActive);

      _data = {
        data: []
      };

      _meta = {};

      const collectedData = [];
      let hasError = false;
      try {
        for (let i_p = 0; i_p < _pages.length; i_p++) {
          const blocks = _pages[i_p].blocks;
          for (let i_b = 0; i_b < blocks.length; i_b++) {
            for (let i_c = 0; i_c < blocks[i_b].columns.length; i_c++) {
              for (let i_f = 0; i_f < blocks[i_b].columns[i_c].fields.length; i_f++) {
                const field = blocks[i_b].columns[i_c].fieldRefs[i_f];
                const value = field.getValue(
                  true,
                  this.extendGetFieldValueFunction,
                  this.extendGetFieldValuePostProcessorFunction
                );

                if (value === null) {
                  hasError = true;
                }
                else if (value !== undefined) {
                  _logger.log('Field Value (' + (field.settings.title ?? field.settings.name) + '): "' + value + '"');
                  collectedData.push({
                    alias: field.settings.name,
                    value: value
                  });
                }
              }
            }
          }
        }
      }
      catch (ex) {
        _logger.error('Error while collecting data', ex);

        formElement.classList.remove(window.mcb.forms.constants.valueCollectingIsActive);
        window.mcb.tracking.track('WebFormsParseValuesError', {
          identifier: ex.message,
          id: 'WebFormParsingValues',
        });

        let token = 'ParseValuesUnexpectedError';
        let fallbackMessage = 'An unexpected error occurred, please refresh the page and try again';
        if (ex.message !== 'Control is not initialized') {
          token = 'ParseValuesFieldNotInitialized';
          fallbackMessage = 'One or more fields are not initialized, please refresh the page and try again';
        }
        else if (ex.message === 'Control has been removed from DOM') {
          token = 'ParseValuesFieldRemoved';
          fallbackMessage = 'One or more fields have been removed from the DOM, please refresh the page and try again';
        }

        formObject.updateFormWithMessage(
          formObject,
          formObject.getMessageFromToken(token, fallbackMessage),
          [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass],
          true
        );

        formElement.querySelector('.mcb-webform--pages').remove();
        formElement.querySelector('.mcb-webform--controls').remove();

        return;
      }

      _logger.trace('OBJECT:', collectedData);

      formElement.classList.remove(window.mcb.forms.constants.valueCollectingIsActive);

      const controls = formElement.querySelector('.' + _classBase + 'controls');
      if (hasError === false) {
        _data = {
          data: collectedData
        };

        if (_data.data === null || _data.data.length === 0) {
          const messageWebFormCannotBeSubmittedIfEmpty = formObject.getMessageFromToken('WebFormCannotBeSubmittedIfEmpty');

          formObject.updateFormWithMessage(
            formObject,
            messageWebFormCannotBeSubmittedIfEmpty,
            [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass],
            false
          );

          controls.classList.remove(_classBase + 'hidden');

          return;
        }

        formObject.onSubmit(formObject);
      }
      else {
        const consolidateAfter = formObject.settings?.collateErrorMessages?.after ?? false;
        const consolidateBefore = formObject.settings?.collateErrorMessages?.before ?? false;
        if (consolidateAfter || consolidateBefore) {
          formElement.querySelectorAll('.mcb-webform--validation--message--consolidated--wrapper').forEach((canvas) => {
            canvas.remove();
          });

          const cw = document.createElement('div');
          cw.classList.add('mcb-webform--validation--message--consolidated--wrapper');
          cw.classList.add(window.mcb.forms.constants.notifications.notification);

          const cl = document.createElement('div');
          cl.classList.add('mcb-webform--validation--message--consolidated--label');
          cl.innerText = formObject.getMessageFromToken('ConsolidatedErrorMessagesLabel');
          cw.appendChild(cl);

          const consolidated = document.createElement('dl');
          consolidated.classList.add('mcb-webform--validation--message--consolidated');
          cw.appendChild(consolidated);

          const formPages = formElement.querySelector('.' + window.mcb.forms.constants.pages.collectionClass);
          const badResults = formPages.querySelectorAll(window.mcb.forms.constants.validation.badResultsSelector);
          badResults.forEach(function (badResult) {
            let brLabel = '';

            const parent = badResult.closest(window.mcb.forms.constants.fields.baseSelector);
            const label = parent.querySelector('.' + window.mcb.forms.constants.fields.labelClass);
            if (label) {
              brLabel = label.innerText;
            }
            else {
              const fieldTitle = parent.dataset.fieldTitle;
              if (fieldTitle) {
                brLabel = fieldTitle;
              }
              else {
                const description = parent.querySelector('.' + window.mcb.forms.constants.fields.descriptionClass);
                if (description) {
                  brLabel = description.innerText;
                }
              }
            }

            const lbl = document.createElement('dt');
            lbl.innerText = brLabel;
            consolidated.appendChild(lbl);

            const msg = document.createElement('dd');
            msg.innerHTML = badResult.outerHTML;
            consolidated.appendChild(msg);
          });

          if (consolidateBefore) {
            const before = formElement.querySelector('.' + window.mcb.forms.constants.notifications.canvasBefore);
            if (before) {
              before.insertAdjacentHTML('afterbegin', cw.outerHTML);
            }
          }

          if (consolidateAfter) {
            const after = formElement.querySelector('.' + window.mcb.forms.constants.notifications.canvasAfter);
            if (after) {
              after.insertAdjacentHTML('beforeend', cw.outerHTML);
            }
          }
        }

        controls.classList.remove(_classBase + 'hidden');
      }
    },
    onSubmit: async function (formObject) {
      _logger.log('Submitting');

      let submitValidator = await formObject.onAuthenticate(formObject);
      if (submitValidator === null) {
        submitValidator = await formObject.onPerformCaptcha(formObject);
      }

      if (submitValidator === null || submitValidator.success === true) {
        executeSubmit(formObject);
      }
    },
    onAuthenticate: async function (formObject) {
      return new Promise(async (resolve) => {
        const authenticateformWrapper = formElement.querySelector('.' + _classBase + 'authenticateform');
        if (authenticateformWrapper === null) {
          resolve(null);
        }
        else {
          formElement.classList.add(window.mcb.forms.constants.authenticationIsActive);

          const results = {
            success: false,
            tryAgain: true
          };

          const formIdentifier = getFormIdentifier(formObject);
          window.mcb.tracking.track('FormAuthenticating', {
            identifier: formIdentifier,
            id: 'Authenticating'
          });

          const win = window.open(formObject.logic.authenticateForm.url, '_auth_window');
          window.addEventListener('message', event => {
            if (event.origin !== window.location.origin || typeof event.data !== 'string') {
              return;
            }

            _logger.trace('Auth return: ', event.data);
            let authResult = null;
            let mess = null;
            if (event.data === '') {
              mess = formObject.getMessageFromToken('AuthenticationMessageWhenCancelling');

              formObject.updateFormWithMessage(
                formObject,
                mess,
                [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass],
                false
              );

              const formElement = document.getElementById(formObject.targetId);
              setControlsEnabledState(formElement, true);
              setVisibilityOfContent(formElement, true, true, true);

              window.mcb.tracking.track('FormSubmitError', {
                identifier: formIdentifier,
                id: 'Authentication Cancelled',
                value: mess
              });
            }
            else {
              try {
                authResult = JSON.parse(event.data);
              }
              catch (err) {
                mess = formObject.getMessageFromToken('AuthenticationMessageUnexpected');

                if (mess !== null) {
                  formObject.updateFormWithMessage(
                    formObject,
                    mess,
                    [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass]
                  );

                  window.mcb.tracking.track('FormSubmitError', {
                    identifier: formIdentifier,
                    id: 'Authentication Exception',
                    value: mess
                  });
                }

                resolve(results);
                return;
              }

              if (typeof authResult.error === "string" && authResult.error !== "") {
                formObject.updateFormWithMessage(
                  formObject,
                  authResult.error,
                  [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass]
                );

                window.mcb.tracking.track('FormSubmitError', {
                  identifier: formIdentifier,
                  id: 'Authentication Error',
                  value: authResult.error
                });

                resolve(results);
                return;
              }
              else if (authResult.code === null) {
                mess = formObject.getMessageFromToken('AuthenticationCodeUnexpectedlyNull');

                if (mess !== null) {
                  formObject.updateFormWithMessage(
                    formObject,
                    mess,
                    [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass]
                  );

                  window.mcb.tracking.track('FormSubmitError', {
                    identifier: formIdentifier,
                    id: 'Authentication Null Code Exception',
                    value: mess
                  });
                }
              }
              else {
                if (authResult !== null) {
                  for (let prop in authResult) {
                    if (authResult.hasOwnProperty(prop)) {
                      const authKey = 'authSigni' + prop[0].toUpperCase() + prop.substring(1);
                      const authValue = authResult[prop];
                      _logger.trace("Add auth Propery: ", authKey, authValue);
                      _meta[authKey] = authValue;
                    }
                  }

                  _logger.trace("Updated Meta Data from Auth Data: ", _meta, authResult);
                  results.success = true;
                }
              }
            }

            window.removeEventListener('message', this);

            formElement.classList.remove(window.mcb.forms.constants.authenticationIsActive);

            resolve(results);
          });

          if (win) {
            // Browser has allowed it to be opened
            win.focus();
          }
          else {
            formObject.updateFormWithMessage(
              formObject,
              formObject.getMessageFromToken('AuthenticationPopUpDenied', 'Please allow popups for this website'),
              [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.messages.errorBlockingClass]
            );

            resolve(results);
          }
        }
      });
    },
    onPerformCaptcha: async function (formObject) {
      return new Promise(async (resolve) => {
        const nuDetectCanvas = formElement.querySelector('.' + _classBase + 'nucaptcha');
        const recaptchaV2Canvas = formElement.querySelector('.' + _classBase + 'recaptcha');

        if (nuDetectCanvas === null && recaptchaV2Canvas === null && _formLogic.recaptcha === null) {
          resolve(null);
          return;
        }

        if (nuDetectCanvas !== null) {
          const results = {
            success: false,
            tryAgain: true
          };

          if (!window.mcb.forms.nudetect.isReady()) {
            window.mcb.tracking.track('FormSubmitError', {
              identifier: 'GenericError',
              id: 'NuDetectNotReady',
              value: 'NuDetect is not ready at submit'
            });

            alert('NuDetect is not ready');
            resolve(results);
          }
          else {
            formElement.classList.add(window.mcb.forms.constants.authenticationIsActive);

            nuDetectCanvas.dataset.formIdentifier = getFormIdentifier(formObject);

            setVisibilityOfContent(formElement, false, false, false);
            window.mcb.forms.nudetect.applyNuDetect(nuDetectCanvas, null, presentNuDetectChallenge, onNuDetectSuccess, onNuDetectError, formObject);

            resolve(results);
          }

          return;
        }

        if (recaptchaV2Canvas !== null) {
          if (window.mcb.forms.recaptcha.hasV2Widget(recaptchaV2Canvas)) {
            // Widget was rendered on a previous submit click and the user hasn't completed it yet.
            // Keep the submit button suppressed so a stray click cannot re-enter onCollectData
            // against the (now hidden) fields.
            jQuery('#' + formObject.targetId + '_btnCommitForm').prop('disabled', true).hide();
            resolve({ success: false, tryAgain: true });
            return;
          }

          // Deferred-render UX mirroring NuDetect: hide the form fields, reveal the (previously
          // empty) captcha canvas, render the v2 widget with a success callback that submits
          // directly — the token cannot expire because the user completes it moments before submit.
          formElement.classList.add(window.mcb.forms.constants.authenticationIsActive);
          setVisibilityOfContent(formElement, false, false, false);
          // Explicit belt-and-braces: setVisibilityOfContent hides .mcb-webform--controls via CSS class,
          // but a stale inline display from a prior jQuery .show() call can override that. Also disable
          // to defeat keyboard-driven activation.
          jQuery('#' + formObject.targetId + '_btnCommitForm').prop('disabled', true).hide();
          recaptchaV2Canvas.classList.remove(window.mcb.forms.constants.hidden);

          // renderV2 awaits api.js load internally, so the iframe is not injected synchronously;
          // refreshFooterVisibility must run *after* the render to see the iframe as a child and
          // keep the footer visible — otherwise it stays hidden from the setVisibilityOfContent call above.
          window.mcb.forms.recaptcha.renderV2(recaptchaV2Canvas, _formLogic.recaptcha.siteKey, function (token) {
            _meta['recaptchaToken'] = token;
            recaptchaV2Canvas.classList.add(window.mcb.forms.constants.hidden);
            formElement.classList.remove(window.mcb.forms.constants.authenticationIsActive);
            refreshFooterVisibility(formElement);
            executeSubmit(formObject);
          }).then(function () {
            refreshFooterVisibility(formElement);
          }).catch(function () {
            formElement.classList.remove(window.mcb.forms.constants.authenticationIsActive);
            blockFormForRecaptcha(formElement);
            recaptchaV2Canvas.classList.add(window.mcb.forms.constants.hidden);
            window.mcb.forms.recaptcha.clearV2Widget(recaptchaV2Canvas);
            formObject.updateFormWithMessage(
              formObject,
              formObject.getMessageFromToken('SubmitErrorText'),
              [window.mcb.forms.constants.messages.messageClass, window.mcb.forms.constants.validation.messageFailureClass]
            );
          });

          window.mcb.tracking.track('FormPresentedCaptcha', {
            identifier: getFormIdentifier(formObject),
            id: 'Displayed Captcha',
            value: 'Displayed reCAPTCHA v2'
          });

          resolve({ success: false, tryAgain: true });
          return;
        }

        resolve(null);
      });
    },
    extendValueObject: function (formObject, obj) {

    },
    getMessageFromToken: function (token, fallbackValue) {
      return window.mcb.forms.data.getMessageFromToken(_targetId, token, fallbackValue);
    },
    updateFormWithMessage: function (formObject, message, messageClasses = [], clearFirst = true, canvasClass = window.mcb.forms.constants.notifications.canvasAfter) {
      const formElement = document.getElementById(formObject.targetId);
      const canvas = formElement.querySelector('.' + canvasClass) ?? formElement.querySelector('.mcb-webform--notification--canvas');
      if (clearFirst) {
        canvas.innerHTML = '';
      }

      const element = document.createElement('div');
      element.classList.add(window.mcb.forms.constants.notifications.notification);
      for (let i = 0; i < messageClasses.length; i++) {
        element.classList.add(messageClasses[i]);
      }

      element.innerHTML = message;
      canvas.append(element);

      if (clearFirst) {
        formElement.scrollIntoView();
      }
    },
    onSubmitServersideDone: onSubmitServersideDone,
    preProcessField: function (field) { },
    enrichFieldFunction: function (fieldObject, jFieldGroup) { },
    extendGetFieldValueFunction: function (fieldObject, disableField) { },
    extendGetFieldValuePostProcessorFunction: function (fieldObject, baseValue) { },
    extendSetValueRecursivelyFunction: function (fieldObject, flattenedValues) { },
    extendSetValueFunction: function (value) { },
    extendValidateAllFunction: function (formObject) { },
    targetId: _targetId,
    logic: _formLogic,
    identity: _identity,
    //fields: _formFields,
    //blocks: _formPages,
    //settings: _formSettings,
    parseEncodedFieldValueAsHtml: function (value) {
      if (value === null) {
        return null;
      }

      return jQuery('<div />')
        .html(decodeURIComponent(value))
        .text();
    },
    getFormIdentifier: getFormIdentifier
  };
};
